(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sale-countdown')) {
    customElements.define('sale-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.deadline = this.parseDeadline(this.dataset.endDate);
        this.timer = this.querySelector('[data-timer]');
        this.notice = this.querySelector('[data-notice]');
        this.digits = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
        this.update();
        if (Number.isFinite(this.deadline) && this.deadline > Date.now()) {
          this.interval = setInterval(() => this.update(), 1000);
        }
      }
      // Require a valid calendar date and explicit offset for a shared global deadline.
      parseDeadline(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-](\d{2}):(\d{2}))$/.exec(value);
        if (!match) return NaN;

        const [, year, month, day, hour, minute, second = '0', , offsetHour = '0', offsetMinute = '0'] = match;
        const daysInMonth = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
        const invalidDate = +month < 1 || +month > 12 || +day < 1 || +day > daysInMonth;
        const invalidTime = +hour > 23 || +minute > 59 || +second > 59;
        const invalidOffset = +offsetHour > 14 || +offsetMinute > 59 || (+offsetHour === 14 && +offsetMinute !== 0);

        return invalidDate || invalidTime || invalidOffset ? NaN : Date.parse(value);
      }

      update() {
        const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
        const active = Number.isFinite(remaining) && remaining > 0;
        this.hidden = !active && !this.hasAttribute('data-design-mode');
        this.timer.hidden = !active;
        this.notice.hidden = active;
        if (!active) {
          this.stop();
          return;
        }
        const values = [
          Math.floor(remaining / 86400),
          Math.floor(remaining / 3600) % 24,
          Math.floor(remaining / 60) % 60,
          remaining % 60
        ];
        this.digits.forEach((digit, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (digit.textContent !== value) digit.textContent = value;
        });
      }

      stop() {
        clearInterval(this.interval);
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
